import { buildDraftApiUrl } from './urlBuilder';

export default async function fetchWithFallback<ResType>(path: string): Promise<ResType> {
  const url = buildDraftApiUrl(path);
  const res = await fetch(url);

  if (!res.ok) {
    throw new Error(`Status error fetching draft ${url}: ${res.status}`);
  }

  return res.json();
}
